module.exports = __webpack_public_path__ + "static/media/Dra-Sabrina-Peirano.39d4b9f4.jpeg";